import { Component, EventEmitter, Injector, OnInit, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AppComponentBase } from '@shared/app-component-base';
import { AlergiaDto, AlergiaServiceProxy, CreatePacienteAlergiaDto, PacienteAlergiaServiceProxy } from '@shared/service-proxies/service-proxies';
import { finalize } from '@node_modules/rxjs/operators';
import { StringUtils } from '@shared/helpers/StringUtils';
import { TipoAlergiaList } from '@shared/model/tipo-alergia-enum.model';

@Component({
  selector: 'app-create-paciente-alergia',
  templateUrl: './create-paciente-alergia.component.html',
    styleUrls: ['./create-paciente-alergia.component.scss'],

})
export class CreatePacienteAlergiaComponent extends AppComponentBase implements OnInit {

  protected alergias: AlergiaDto[] = []
  protected pacienteAlergia: CreatePacienteAlergiaDto = new CreatePacienteAlergiaDto();
  protected tiposAlergias: TipoAlergiaList = new TipoAlergiaList();
  protected saving: boolean = false;
  protected showList: boolean = false;
  public pacienteId: string = "";

  @Output() onSave = new EventEmitter<any>()

  constructor(
    injector: Injector,
    private readonly _alergiaService: AlergiaServiceProxy,
    private readonly _pacienteAlergiaService: PacienteAlergiaServiceProxy,
    public modalService: BsModalRef,
  ) {
    super(injector)
  }

  ngOnInit(): void {
    this.pacienteAlergia.pacienteId = this.pacienteId
    this.getAlergias();
  }

  protected save(): void {
    if (!this.isFormValided()) return;
    abp.ui.setBusy();
    this.saving = true;
    this._pacienteAlergiaService.create(this.pacienteAlergia).pipe(
      finalize(() => {
        this.saving = false;
        abp.ui.clearBusy();
      })
    ).subscribe((result) => {
      this.onSave.emit();
      this.modalService.hide();
    })
  }

  protected getAlergias(): void {
    abp.ui.setBusy();
    this.showList = true;
    this._alergiaService.getAlergias(this.pacienteAlergia.substancia).pipe(
      finalize(() => {
        abp.ui.clearBusy();
      })
    ).subscribe((result) => {
      this.alergias = result;
    })
  }

  protected selectAlergia(alergia: AlergiaDto): void{
    this.pacienteAlergia.substancia = alergia.substancia;
    this.pacienteAlergia.tipoAlergia = alergia.tipoAlergia;
    this.showList = false;
  }

  private isFormValided(): boolean {
    var validations = [
      { condition: StringUtils.isNullOrEmpty(this.pacienteAlergia.substancia), message: "Informe a alergia.." },
      { condition: StringUtils.isNullOrEmpty(this.pacienteAlergia.tipoAlergia), message: "Informe o tipo da alergia" },
    ];

    for (const validation of validations) {
      if (validation.condition) {
        this.notify.warn(this.l(validation.message));
        return false;
      }
    }

    return true;
  }
}
